import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { marked as f } from "../node_modules/.pnpm/marked@18.0.11/node_modules/marked/lib/marked.esm.js";
import purify$1 from "../node_modules/.pnpm/dompurify@3.4.14/node_modules/dompurify/dist/purify.es.js";
import { LitElement, css, html, nothing } from "lit";
import { property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { markdownContentStyles } from "@progressive-development/pd-shared-styles";
//#region src/pd-markdown-view/PdMarkdownView.ts
/**
* @license
* Copyright (c) 2026 PD Progressive Development UG. All rights reserved.
*/
/** Own DOMPurify instance so the link hook stays local to this component. */
var purify = purify$1(window);
/** Whitelist mirrors exactly what markdownContentStyles covers — anything
*  outside it would render unstyled and is dropped instead. */
var SANITIZE_OPTIONS = {
	ALLOWED_TAGS: [
		"p",
		"br",
		"hr",
		"ul",
		"ol",
		"li",
		"blockquote",
		"h1",
		"h2",
		"h3",
		"h4",
		"a",
		"strong",
		"em",
		"b",
		"i",
		"del",
		"code",
		"pre",
		"table",
		"thead",
		"tbody",
		"tr",
		"th",
		"td"
	],
	ALLOWED_ATTR: ["href"]
};
if (purify.isSupported) purify.addHook("afterSanitizeAttributes", (node) => {
	if (node.tagName === "A") {
		node.setAttribute("target", "_blank");
		node.setAttribute("rel", "noopener noreferrer");
	}
});
/**
* Renders a markdown string as sanitized HTML using the shared
* markdownContentStyles tokens. Display-only counterpart to
* pd-markdown-input — no editor, no tiptap payload.
*
* Sanitizing (DOMPurify, tag whitelist) is a fixed part of the pipeline:
* the input is user content and raw HTML inside the markdown is never
* rendered.
*
* @summary Sanitized markdown display (marked + DOMPurify + shared styles).
*
* @tagname pd-markdown-view
*/
var PdMarkdownView = class extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.markdown = "";
		this._html = "";
	}
	static {
		this.styles = [css`
      :host {
        display: block;
      }
    `, markdownContentStyles];
	}
	willUpdate(changedProps) {
		if (changedProps.has("markdown")) this._html = this.markdown ? purify.sanitize(f.parse(this.markdown, {
			async: false,
			breaks: true
		}), SANITIZE_OPTIONS) : "";
	}
	render() {
		if (!this._html) return nothing;
		return html`<div class="md-content">${unsafeHTML(this._html)}</div>`;
	}
};
__decorate([property()], PdMarkdownView.prototype, "markdown", void 0);
__decorate([state()], PdMarkdownView.prototype, "_html", void 0);
//#endregion
export { PdMarkdownView };
